import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchPatientAction } from '../../../reducers/patients';
import {
  cancelUpdateRxFormShippingAction,
  updateRxFormShippingDataAction
} from '../../../reducers/rxForms';
import {
  closeGlobalBackdropAction,
  openGlobalBackdropAction
} from '../../../reducers/globalBackdrop';
import InitialCaseCompletionDialog from './InitialCaseCompletionDialog';

const UpdateRxFormShippingDialog = ({
  rxForm,
  submit,
  close,
  reloadPatient,
  openBackDrop,
  closeBackdrop
}) => {
  const handleContinue = ({ tracking_number: trackingNumber }) => {
    openBackDrop();
    submit(rxForm, trackingNumber)
      .then(() => {
        reloadPatient(rxForm);
        close();
      })
      .catch(() => {})
      .finally(() => {
        closeBackdrop();
      });
  };

  const getInitialValues = () => {
    const initial = {
      tracking_number: ''
    };

    if (!rxForm) {
      return initial;
    }

    return {
      tracking_number: rxForm.tracking_number
    };
  };

  return (
    <InitialCaseCompletionDialog
      open={rxForm !== null}
      initialValues={getInitialValues()}
      onContinue={handleContinue}
      titleText="Update Shipping Information"
      acceptButtonText="Update"
      setOpen={close}
      fullWidth
    />
  );
};

UpdateRxFormShippingDialog.propTypes = {
  rxForm: PropTypes.object,
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  reloadPatient: PropTypes.func.isRequired,
  openBackDrop: PropTypes.func.isRequired,
  closeBackdrop: PropTypes.func.isRequired
};

UpdateRxFormShippingDialog.defaultProps = {
  rxForm: null
};

export default connect(
  state => ({
    rxForm: state.rxForms.selection.updateRxFormShipment
  }),
  dispatch => ({
    submit: (rxForm, trackingNumber) => {
      return dispatch(
        updateRxFormShippingDataAction(rxForm.id, {
          tracking_number: trackingNumber
        })
      );
    },
    close: () => dispatch(cancelUpdateRxFormShippingAction()),
    reloadPatient: rxForm => dispatch(fetchPatientAction(rxForm.patient_id)),
    openBackDrop: () => dispatch(openGlobalBackdropAction()),
    closeBackdrop: () => dispatch(closeGlobalBackdropAction())
  })
)(UpdateRxFormShippingDialog);
